module.exports = __webpack_public_path__ + "static/media/banner_mercedes_mid.d8f985a2.jpg";